const LibSatUtil = {
    ObterValores: function() {
        const currentUrl = window.location.href;

        if(currentUrl.includes('localhost')) {
        return {
            ambienteLibSat: 'TI',
            apiKeyLibSat: 'qzVljgM5Bg27yb7UarbBw2n6Q2nHPS1l2EXnvYWO',
        };
        } else if (currentUrl.indexOf('-homol.') !== -1) {
        return {
            ambienteLibSat: 'HML',
            apiKeyLibSat: 'dvqQV3TXRG60bkNrAqxPS4BsHup69efh6Zcj3RqB',
        };
        } else {
        return {
            ambienteLibSat: 'PRD',
            apiKeyLibSat: 'SewC7ePkWv91PMrbPpLj63ajtOg4AUPN7LxmVN40',
        }
        }
    }
};

//function
function preencherLibSat(type, event) {
    try {
        if(typeof LibSat.sendDataAnalytics === 'function') {
        // LibSat.debugView(true);
        LibSat.sendDataAnalytics(type, event, LibSatUtil.ObterValores().ambienteLibSat, 'ccf', LibSatUtil.ObterValores().apiKeyLibSat);
        };
    } catch (e){
        console.error('Erro ao enviar Lib SAT', e);
    };
};

// Expondo no escopo global
window.LibSatUtil = LibSatUtil;
window.preencherLibSat = preencherLibSat;
